import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["itemSelect", "itemInfo", "unitDisplay", "unitInput", "quantityInput", "stockWarning"]

  connect() {
    if (this.hasItemSelectTarget && this.itemSelectTarget.value) {
      this.itemChanged()
    }
  }

  itemChanged() {
    const selectedOption = this.itemSelectTarget.selectedOptions[0]

    if (!selectedOption || !selectedOption.value) {
      this.clearItemInfo()
      return
    }

    // 사용 단위 기준으로 표시 (DB에 이미 사용 단위로 저장됨)
    const useUnit = selectedOption.dataset.useUnit || ''
    const currentStock = parseFloat(selectedOption.dataset.currentStock) || 0

    this.currentStock = currentStock
    this.useUnit = useUnit

    if (this.hasItemInfoTarget) {
      this.itemInfoTarget.innerHTML = `<span class="text-gray-500">현재 재고: <span class="font-medium text-gray-700">${this.formatNumber(currentStock)} ${useUnit}</span></span>`
    }

    if (this.hasUnitDisplayTarget) {
      this.unitDisplayTarget.textContent = useUnit || '-'
    }
    if (this.hasUnitInputTarget) {
      this.unitInputTarget.value = useUnit
    }

    // Check quantity after item change
    this.quantityChanged()
  }

  quantityChanged() {
    if (!this.hasStockWarningTarget || !this.hasQuantityInputTarget) return

    const quantity = parseFloat(this.quantityInputTarget.value) || 0
    const currentStock = this.currentStock || 0

    if (quantity > currentStock && currentStock >= 0) {
      const shortage = quantity - currentStock
      this.stockWarningTarget.innerHTML = `
        <div class="flex items-center gap-2 text-amber-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
          <span class="text-sm">재고 부족: ${this.formatNumber(shortage)} ${this.useUnit || ''} (마이너스 재고 발생)</span>
        </div>
      `
    } else {
      this.stockWarningTarget.innerHTML = ''
    }
  }

  clearItemInfo() {
    if (this.hasItemInfoTarget) {
      this.itemInfoTarget.innerHTML = ''
    }
    if (this.hasUnitDisplayTarget) {
      this.unitDisplayTarget.textContent = '-'
    }
    if (this.hasUnitInputTarget) {
      this.unitInputTarget.value = ''
    }
    if (this.hasStockWarningTarget) {
      this.stockWarningTarget.innerHTML = ''
    }
    this.currentStock = 0
    this.useUnit = ''
  }

  formatNumber(num) {
    if (num === null || num === undefined) return '0'
    return Number.isInteger(num) ? num.toString() : parseFloat(num.toFixed(2)).toString()
  }
}
